document.addEventListener("DOMContentLoaded", () => {
	initBtnApply();
	initBtnCounter();
});

function initBtnApply() {
	let buttons = document.querySelectorAll(".banner-main form .btn, .get-started form .btn, footer#footer");
	if (!buttons.length) return;

	checkBtnInView();
	window.addEventListener("scroll", checkBtnInView);

	function checkBtnInView() {
		let btnTarget = document.querySelector(".btn-apply");
		buttons.forEach((el, i) => {
			if (isElementInViewport(el)) {
				document.body.classList.add("btn-apply-hidden-" + i);
			} else {
				document.body.classList.remove("btn-apply-hidden-" + i);
			}
		});
	}
}

function initBtnCounter() {
	let holder = document.querySelector(".counter-holder");
	if (!holder) return;

	let storageTime = localStorage.getItem("storageTime");
	let storageNum = localStorage.getItem("storageNum");
	let curDate = new Date();
	let num = holder.querySelector(".number");
	let startNum = storageNum ?? 750;
	let timeout = 900000;
	let expiredTime = curDate.getDate() + 1;
	num.innerText = startNum;
	setInterval(() => {
		startNum = +startNum + randomBetween(2, 4);
		num.innerText = startNum;
		if (storageTime === null && curDate.getTime() > storageTime) {
			localStorage.removeItem("storageTime");
			localStorage.removeItem("storageNum");
			localStorage.setItem("storageTime", curDate.setDate(expiredTime));
			localStorage.setItem("storageNum", +startNum);
		}
		localStorage.setItem("storageNum", +startNum);
	}, timeout);
}

function randomBetween(min, max) {
	return Math.floor(
		Math.random() * (max - min) + min
	);
}


function isElementInViewport(el, horK, vertK) {
	horK = horK || 0.75;
	vertK = vertK || 0.5;
	let rect = el.getBoundingClientRect();
	let windowHeight = (window.innerHeight || document.documentElement.clientHeight);
	let windowWidth = (window.innerWidth || document.documentElement.clientWidth);
	let vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
	let horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

	return (vertInView && horInView);
}